import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";

import { fetchZipCodes, fetchAnalytics } from "../Actions";

import SideBar from "./Sidebar";
import WeeklyRiskTrend from "./graphs/WeeklyRiskTrend";
import RiskDistribution from "./graphs/RiskDistribution";

import audioImg from "../Assets/images/dashboard/audio.svg";
import assessmentsImg from "../Assets/images/dashboard/doctor.svg";
import virusImg from "../Assets/images/dashboard/virus.svg";

import * as moment from "moment";
// import DatePicker from "react-datepicker";
import ClipLoader from 'react-spinners/ClipLoader';
import { DateRangePickerComponent } from '@syncfusion/ej2-react-calendars';
import Navbar from "./Navbar";
import HomePage from "./HomePage";
import Topbar from "./Topbar";
// import "react-datepicker/dist/react-datepicker.css";


const Dashboard = (props) => {
  let date = moment(new Date())
  
  const [endDate, setEndDate] = useState(new Date(date.add(1, 'day').valueOf()));
  const [startDate, setStartDate] = useState(new Date(date.subtract(1, 'month').valueOf()));

  // const [assesmentsperPatient, setapp] = useState();
  // var assesmentsperPatient;
  
  const [loading, setLoading] = useState(true);
  const [selectedOption, setSelectedOption] = useState('');
  const [showDatePicker, setShowDatePicker] = useState(false);
  const dateRangePickerRef = useRef(null);
  const [dates1, setDates1] = useState('');
  const [dates2, setDates2] = useState('');

  useEffect(() => { 


    const startDate1 = moment(startDate).format("YYYY-MM-DD")
    const endDate1 = moment(endDate).format("YYYY-MM-DD")
    if (endDate !== null && startDate !== null) {
      setLoading(true)
      props.fetchAnalytics(endDate1, startDate1).then(() => setLoading(false));
      setDates1(startDate1.toLocaleString());
      setDates2(endDate1.toLocaleString());
    }
   else{
    setLoading(true);
    props.fetchAnalytics().then(() => setLoading(false));
    // setDates1(startDate1.toLocaleString());
    // setDates2(endDate1.toLocaleString());
   }


  
    // setapp = Number(props.analytics.assessmentsCount / props.analytics.records.length )
  
  }, [endDate, startDate]);

  
  // var inPatient = 0;
  // var outPatient = 0;
  // var completedPatients = 0;
  // var totalAssessments = 0;
  // for (var i = 0; i < props.patient.count; i++) {
  //   totalAssessments += props.patient.patient[i].records.length;
  //   if (props.patient.patient[i].patient_type === "In Patient") {
  //     inPatient = inPatient + 1;
  //   }
  //   if (props.patient.patient[i].patient_type === "Out Patient") {
  //     outPatient = outPatient + 1;
  //   }
  //   if (props.patient.patient[i].status === "COMPLETED") {
  //     completedPatients = completedPatients + 1;
  //   }
  // }

   

  const [oneWeekPressed,setOneWeekPressed] = useState(false)
  const [twoWeekPressed,setTwoWeekPressed] = useState(false)
  const [oneMonthPressed,setOneMonthPressed] = useState(true)
  const [threeMonthPressed,setthreeMonthPressed] = useState(false)
  const [sixMonthPressed,setSixMonthPressed] = useState(false)

  const oneWeekHandler = () => {
    setOneWeekPressed(true);
    setTwoWeekPressed(false);
    setOneMonthPressed(false);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(7, "day").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const twoWeekHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(true);
    setOneMonthPressed(false);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(14, "day").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneMonthHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(false);
    setOneMonthPressed(true);
    setthreeMonthPressed(false);
    setSixMonthPressed(false);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(1, "month").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const threeMonthHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(false);
    setOneMonthPressed(false);
    setthreeMonthPressed(true);
    setSixMonthPressed(false);
    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(2, "month").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const sixMonthHandler = () => {
    setOneWeekPressed(false);
    setTwoWeekPressed(false);
    setOneMonthPressed(false);
    setthreeMonthPressed(false);
    setSixMonthPressed(true);

    let newStartdate = moment(new Date());
    let newEnddate = moment(new Date());
    setStartDate(new Date(newStartdate.subtract(6, "month").valueOf()));
    setEndDate(new Date(newEnddate.add(1, "day").valueOf()));
  };
  const oneDayHandler = () => {
    setSelectedOption('1day');
    const today = moment().startOf('day').toDate();
    setStartDate(today); // Set start date to today
    setEndDate(today); // Set end date to today
  };
  const oneYearHandler = () => {
    setSelectedOption('1year');
    const startDate = moment().subtract(1, 'year').toDate();
    const endDate = moment().toDate();
    setStartDate(startDate); // Set start date 1 year ago
    setEndDate(endDate); // Set end date to end of this year
  };
  console.log(props);

  const [width, setWidth] = React.useState(window.innerWidth);
  const breakpoint = 1000;
  React.useEffect(() => {
    const handleResizeWindow = () => setWidth(window.innerWidth);
    // subscribe to window resize event "onComponentDidMount"
    window.addEventListener("resize", handleResizeWindow);
    return () => {
      // unsubscribe "onComponentDestroy"
      window.removeEventListener("resize", handleResizeWindow);
    };
  }, []);

  {/* {props.analytics.assessmentsCount !== 0 ? (props.analytics.assessmentsCount/props.analytics.patientsCount).toFixed(2) : 0} */}

  // const dividedResult = props.analytics.assessmentsCount/props.analytics.patientsCount
  // const roundedResult = Number.isInteger(dividedResult) ? dividedResult.toFixed(0) : dividedResult.toFixed(2);
  const dividedResult = props.analytics.assessmentsCount !== 0 ? (props.analytics.assessmentsCount / props.analytics.patientsCount) : 0;
  const roundedResult = dividedResult !== 0 ? (Number.isInteger(dividedResult) ? dividedResult.toFixed(0) : dividedResult.toFixed(2)) : 0;

  
  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);

    // Call respective handler functions based on selected option
    if (value === '1week') {
      oneWeekHandler();
      setShowDatePicker(false);
    } else if (value === '1day') {
      oneDayHandler();
      setShowDatePicker(false);
    } else if (value === '1month') {
      oneMonthHandler();
      setShowDatePicker(false);
    } else if (value === '1year') {
      oneYearHandler();
      setShowDatePicker(false);
    } else if (value === 'custom') {
      setShowDatePicker(true);
    }
  };

  const handleRangeSelected = (args) => {
    // debugger
    const startDate1 = args.value[0];
    const endDate1 = args.value[1];

    const startDate2 = moment(startDate1).format(("YYYY-MM-DD"))
    const endDate2 = moment(endDate1).format(("YYYY-MM-DD"))
    
    setStartDate(startDate2);
    setEndDate(endDate2);
    setSelectedOption("")
  };
  const handleDateRangePickerRef = (ref) => {
    if (ref && selectedOption === 'custom') {
      ref.show();
    }
  };

  if (width > breakpoint) {
    if (loading) {
      return (
        <div className="loadingdiv">
          <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
        </div>
      );
    } else
    return (
      <>
      {/* <Navbar home/> */}
      <div className="dashboard" style={{display: "flex", flexDirection: "row"}}>
        {/* <SideBar home /> */}
        {localStorage.rpm === 'rpm' && <HomePage />}
        <div className="dashboard__content">
          <Topbar />
          <div className="dateSelection">
            <select className="selectDate" id="duration" value={selectedOption} onChange={handleChange}>
              <option value="1month">Date Range</option>
              <option value="1month">1 Month</option>
              <option value="1week">1 Week</option>
              <option value="1year">1 Year</option>
              <option value="1day">1 Day</option>
              <option value="custom" key="">Custom</option>
            </select>
            {showDatePicker && (
              <div className="dateRangePicker">
                <DateRangePickerComponent
                  id="daterangepicker"
                  placeholder="Select a range"
                  startDate={startDate}
                  endDate={endDate}
                  showClearButton={false}
                  onChange={handleRangeSelected}
                  ref={(ref) => handleDateRangePickerRef(ref)}
                />
              </div>
            )}
            <div className="dates-container">
              <p className="dates">{dates1} </p>
              <p className="dates">to</p>
              <p className="dates">{dates2} </p>
            </div>
          </div>
          <div className="dashboard__summary">
            <div className="card2">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Patients Scanned</p>
                <img style={{height: '35px', margin: '50px 0 15px 0'}} src={audioImg} alt="patients" />
                <p className="card2--info__count">
                  {props.analytics.patientsCount}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#46360999" }}
              >
                Total number of patients assessed in the selected time period.
              </p>
            </div>
            <div className="card2 card2--high-risk">
              <div className="card2--info__content">
                <p className="card2--info__title">Patients with High LHI</p>
                <img src={virusImg} alt="high risk" style={{marginTop:"30px"}} />
                <p className="card2--info__count">
                  {props.analytics.highRiskCount}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#ff536899" }}
              >
                Number of patients found with high LHI in the selected time period.
              </p>
            </div>
            <div className="card2 card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Assessments per Patient</p>
                <img src={assessmentsImg} alt="assessments" style={{marginTop:"30px"}} />
                <p className="card2--info__count">
                  {roundedResult}
                  {/* {props.analytics.assessmentsCount !== 0 ? (props.analytics.assessmentsCount/props.analytics.patientsCount).toFixed(2) : 0} */}
                  {/* {
                    props.analytics.records.length !== 0 ? 
                    parseFloat(props.analytics.assessmentsCount) / parseFloat(props.analytics.records.length) : 
                    0
                  } */}
                  {/* {inPatient}/{outPatient} */}
                  {/* {(
                    props.analytics.assessmentsCount /
                    props.analytics.records.length
                    ).toFixed(1)} */}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#46360999" }}
              >
                Average number of assessments per patient in the selected time period.
              </p>
            </div>
          </div>
          {localStorage.validation != "true" ? (
            <div className="dashboard__analytics">
              {/* uncomment this WeeklyRiskTrend when ever you required add below link where you want
          weekly risk trends */}

              <WeeklyRiskTrend />

              {/* <div className="dashboard__analytics__risk">
            <RiskDistribution />
          </div> */}
            </div>
          ) : (
            <div className="dashboard__analytics">
              {/* uncomment this WeeklyRiskTrend when ever you required add below link where you want
          weekly risk trends */}

              <WeeklyRiskTrend />

              {/* <div className="dashboard__analytics__risk">
            <RiskDistribution />
          </div> */}
            </div>
          )}
        </div>
      </div>
      </>
    );
  } else {
    if (loading) {
      return (
        <div className="loadingdiv">
          <ClipLoader color={"#fd8c00"} loading={loading} size={30} />
        </div>
      );
    } else
    return (
      <>
        {/* <Navbar home/> */}
      <div className="dashboard">
        {localStorage.rpm === 'rpm' && <HomePage />}
        {/* <SideBar home /> */}
        {/* <div className="mobiletitle" style={{ paddingLeft: "2rem" }}>
          Swaasa
        </div> */}
        <div className="dashboard__content">
          <Topbar />
          {/* <div className="card2--line-chart__date1">
            <p>Filter</p>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={startDate}
              onChange={(date) => setStartDate(date)}
            />
            <span style={{ paddingLeft: "1rem", paddingRight: "1rem" }}>
              to
            </span>
            <DatePicker
              dateFormat="dd/MM/yyyy"
              selected={endDate}
              onChange={(date) => setEndDate(date)}
            />
          </div> */}
          <div className="dashboard__summary">
            <div className="card2">
              <div className="card2--info__content">
                <p className="card2--info__title">Total Patients Scanned</p>
                <img src={audioImg} alt="patients" />
                <p className="card2--info__count">
                  {props.analytics.records.length}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#46360999" }}
              >
                Total number of patients registered in the selected location
              </p>
            </div>
            <div className="card2 card2--high-risk">
              <div className="card2--info__content">
                <p className="card2--info__title">Patients with High LHI (7-10)</p>
                <img src={virusImg} alt="high risk" />
                <p className="card2--info__count">
                  {props.analytics.highRiskCount}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#ff536899" }}
              >
                Number of patients who have been found with high LHI
              </p>
            </div>
            <div className="card2 card2--assessments">
              <div className="card2--info__content">
                <p className="card2--info__title">Assessments per Patient</p>
                <img src={assessmentsImg} alt="assessments" />
                <p className="card2--info__count">
                  {/* {(
                    props.analytics.assessmentsCount /
                    props.analytics.records.length
                  ).toFixed(1)} */}
                  {props.analytics.records.length !== 0
                    ? parseFloat(props.analytics.assessmentsCount) /
                      parseFloat(props.analytics.records.length)
                    : 0}
                </p>
              </div>
              <p
                className="card2--info__description"
                style={{ color: "#1ad94799" }}
              >
                Number of assessments divided by the total Number of patients
                scanned
              </p>
            </div>
          </div>
          <div className="dashboard__analytics">
            <WeeklyRiskTrend />
            {/* <div className="dashboard__analytics__risk">
              <RiskDistribution />
            </div> */}
          </div>
        </div>
      </div>
      </>
    );
  }
};

const mapStateToProps = (state) => ({
  analytics: state.analytics,
});

export default connect(mapStateToProps, { fetchAnalytics })(Dashboard);
